export default "__VITE_ASSET__DuEnh90I__"